import axios from 'axios'

const instance = axios.create({
  baseURL: 'https://api.nbtongzhou.com/',
  timeout: 10000
})
instance.interceptors.response.use(function (res) {
  const data = res.data
  if (data.code === '0') {
    return data
  } else {
    throw data
  }
}, function (error) {
  return Promise.reject((error.response && error.response.data) || error)
})
export default instance



// WEBPACK FOOTER //
// ./src/js/ajax.js